module.exports = __webpack_public_path__ + "static/x-button-9de3f8bd000d93dfe6e61d19dcc4645e.png";